var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHighDifficultyLevel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.675049,
    width: 24,
    height: 24,
    rx: 6,
    fill: "#FFF3E4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_233_3416)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.34794 19.1098V14.7272C8.34794 14.1533 7.87838 13.6837 7.30446 13.6837C6.73055 13.6837 6.26099 14.1533 6.26099 14.7272V19.1098C6.26099 19.6837 6.73055 20.1533 7.30446 20.1533C7.87838 20.1533 8.34794 19.6837 8.34794 19.1098Z",
    fill: "#FAA53D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6521 19.1096C15.6521 19.6835 16.1217 20.1531 16.6956 20.1531C17.2695 20.1531 17.7391 19.6835 17.7391 19.1096V6.24001C17.7391 5.6661 17.2695 5.19653 16.6956 5.19653C16.1217 5.19653 15.6521 5.6661 15.6521 6.24001V19.1096Z",
    fill: "#FAA53D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0435 10.4835V19.1096C13.0435 19.6835 12.5739 20.153 12 20.153C11.4261 20.153 10.9565 19.6835 10.9565 19.1096V10.4835C10.9565 9.90957 11.4261 9.44 12 9.44C12.5739 9.44 13.0435 9.90957 13.0435 10.4835Z",
    fill: "#FAA53D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_233_3416"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 4.67505)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighDifficultyLevel);
export default __webpack_public_path__ + "static/media/high-difficulty-level.789b16634ea0b00c8ab69a72cf7c7b02.svg";
export { ForwardRef as ReactComponent };